import React from 'react'
import { withRouter } from "react-router-dom";
import { TableOp } from '../../../components/table/TableOps.tsx';
import TableComponent from '../../../components/table/TableOps';
import Chofer from './Chofer'
import ACCESS from '../../../ACCESS.js';

class Circuitos extends TableComponent {

  componentDidMount() {
    this.tableConfig(
      { dataUrl: 'chofer/filter', deleteUrl: 'chofer/delete', deleteField: 'chofer_nombre', modUrl: '/Catalogo/Chofer' },
      TableOp.Table('Choferes', [
        { label: 'Chofer', id: 'chofer_nombre' },
        { label: 'RFC', id: 'chofer_rfc' },
        { label: 'Numero Licencia', id: 'chofer_numero_licencia' },
      ], [
        { id: 'edit', icon: 'edit', access: [ACCESS.CATALOGO_CHOFERES.EDITAR_CATALOGO] },
        { id: 'delete', icon: 'delete', access: [ACCESS.CATALOGO_CHOFERES.ELIMINAR_CATALOGO] },
      ]))
    this.table();
  }

  render() {
    return (
      <div>
        <div>
          {
             
          <Chofer  onSave={() => { this.table() }}></Chofer>
        }
        {
           
          <this.TableRender  />
        }
        </div>
      </div>
    )
  }
}

export default withRouter(Circuitos)